import storageFactory from '@kcuf/storage-factory';
export default storageFactory('Auth.Console', {
  id: '',
  name: '',
  token: '',
  tenantId: '',
  timeExpired: 0
});
//# sourceMappingURL=auth.js.map